"use strict";
/**
 * @module Services.Send
 */
Object.defineProperty(exports, "__esModule", { value: true });
var require_non_null_1 = require("./../util/require-non-null");
/**
 * Response from service that provides a count or a list of errors.
 */
var CountOrParserErrors = /** @class */ (function () {
    /**
     * Create a new CountOrParserErrors instance.
     *
     * @param sent  the number of sessions that the message was sent to
     * @param errors  any errors that occurred
     */
    function CountOrParserErrors(count, errors) {
        this.count = require_non_null_1.requireNonNull(count, 'count');
        this.errors = require_non_null_1.requireNonNull(errors, 'errors');
    }
    return CountOrParserErrors;
}());
exports.CountOrParserErrors = CountOrParserErrors;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/count-or-parser-errors.js
// module id = 1928
// module chunks = 1